import { render, staticRenderFns } from "./StepListaTipoServico.vue?vue&type=template&id=2a8797a4"
import script from "./StepListaTipoServico.vue?vue&type=script&lang=js"
export * from "./StepListaTipoServico.vue?vue&type=script&lang=js"
import style0 from "./StepListaTipoServico.vue?vue&type=style&index=0&id=2a8797a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports